import React from 'react';
import { Redirect } from "react-router-dom";

let data,
    sessionWasRestored = false,
    playerAmount,
    playerEmail,
    gameTime,
    round,
    localRoute,
    sessionCode,
    timeLeft,
    roundSwitch,
    partOfGame = 1;

export default {

  setCookie(name,value,days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/; domain=" + document.domain ;
  },

  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  },

  eraseCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' + document.domain;
  },

  getData(which) {

    switch (which) {
      case 'sessionWasRestored':
        return sessionWasRestored;

      case 'playerAmount':
        return playerAmount;

      case 'gameTime':
        return gameTime;

      case 'playerEmail':
        return playerEmail;

      case 'round':
        return round;

      case 'roundSwitch':
        return roundSwitch;

      case 'localRoute':
        return localRoute;

      case 'partOfGame':
        return partOfGame;

      case 'sessionCode':
        return sessionCode;
      case 'timeLeft':
        return timeLeft;
      case 'partTime':
        if(gameTime !== undefined){
          return gameTime[partOfGame];
        }
        return false;
      default:
        return data;
    }
  },

  storeData(which, array) {
    if(which === 'sessionWasRestored') {
      sessionWasRestored = array;
    } else if (which === 'playerAmount') {
      playerAmount = array;
    } else if (which === 'playerEmail'){
      playerEmail = array;
    } else if (which === 'roundSwitch'){
      roundSwitch = array;
    } else if (which === 'gameTime'){
      gameTime = array;
    } else if (which === 'round') {
      round = array;
    } else if (which === 'localRoute') {
      localRoute = array;
    } else if (which === 'sessionCode') {
      sessionCode = array;
    } else if (which === 'partOfGame') {
      partOfGame = array;
    } else if (which === 'timeLeft') {
      timeLeft = array;
    } else {
      data = array;
    }
  },

  getNewRoundId(){
    let currentPart = this.getData('partOfGame');
    const nextPart =  currentPart + 1;
    this.storeData('partOfGame', nextPart);
  },

  getNextRedirect(){
    var currentLocation = this.getData('localRoute');
    var currentRound = this.getData('round');

    if (currentRound < 3) {
      switch (currentLocation) {
        case '/':
          return <Redirect to="/intro"/>;

        case '/intro':
          this.getNewRoundId();
          return <Redirect to="/preparation"/>;

        case '/preparation':
          this.getNewRoundId();
          return <Redirect to="/video"/>;

        case '/video':
          this.getNewRoundId();
          return <Redirect to="/game"/>;

        case '/game':
          this.getNewRoundId();
          return <Redirect to="/roundswitch"/>;

        case '/roundswitch':
          this.getNewRoundId();
          return <Redirect to="/income"/>;

        case '/income':
          this.getNewRoundId();
          return <Redirect to="/scenario"/>;

        case '/scenario':
          this.getNewRoundId();
          return <Redirect to="/game"/>;

        default:
          return <Redirect to="/game"/>
      }
    } else {
      switch (currentLocation) {
        case '/game':
          return <Redirect to="/endscore"/>;

        case '/endscore':
          return <Redirect to="/"/>;

        default:
          return <Redirect to="/game"/>
      }
    }
  },

  formatForOutput(number, decimals, min, max) {
    const minN = typeof min === 'number' ? min : -Infinity;
    const maxN = typeof max === 'number' ? max : Infinity;
    let output = Math.min(
      // Return the biggest number. Given -3 as a value:
      // -3 < -∞ so the result is -3.
      // If the minimum value is 0:
      // -3 > 0 so the result is 0.
      Math.max(number, minN),
      // Return the smallest number. Given 30 as a value:
      // 30 < ∞ so the result is 30.
      // If the maximum value is 10:
      // 30 > 10 so the result is 10.
      maxN // return the smallest number
    );
    if (typeof decimals === 'number') {
      output = output.toFixed(decimals);
    }
    return output.toString().replace('.', ',');
  }

}



// WEBPACK FOOTER //
// ./src/functions/player.js